import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { Router } from '@angular/router';

import { APP_ROUTES } from 'src/app/app.routes';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'emp-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, TranslatePipe, MatButtonModule, MatFormFieldModule, MatInputModule]
})
export class NewPasswordComponent implements OnInit {
  private router = inject(Router);

  public form = new FormGroup({
    password: new FormControl<string>(null, {
      validators: [Validators.required, Validators.minLength(8)]
    }),
    confirmPassword: new FormControl<string>(null, {
      validators: [Validators.required, Validators.minLength(8), passwordValidator]
    })
  });
  public hidePassword = true;

  ngOnInit(): void {
    this.form.valueChanges.subscribe(() => {
      this.form.controls.confirmPassword.updateValueAndValidity({ emitEvent: false });
    });
  }

  public onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else {
      void this.router.navigate([APP_ROUTES.login]);
    }
  }
}

const passwordValidator: ValidatorFn = function (control: AbstractControl) {
  if (control.value !== control.parent?.get('password').value) {
    return { notSame: true };
  } else {
    return null;
  }
};
